export const CareAgentTypes = {
  CCMManager: 'ccmManager',
  PATManager: 'patManager',
  OnboardingManager: 'onboardingManager',
  CCMPATManager: 'ccmPatManager',
  CCMOnboardingAgent: 'ccmOnboardingAgent',
};
